// original endpoints (pre-prefix): /api/internal/users, /api/debug/config, /api/v2/export